import React from "react";
import ReactApexChart from "react-apexcharts";

export default function AreaChart({
  title,
  chartData,
  height = 180,
  lineClr = "#417EF9",
  chartClrs,
  lineOnly,
  hideMarker = true,
  yAxisTitle = ""
}) {
  let series = [
    {
      name: chartData?.name || "PandaStack",
      type: "area",
      data: chartData?.data || [10, 41, 35, 51, 49, 34, 69, 91, 14].sort(() => .5 - Math.random()),
    },
  ];
  
  let options = {
    chart: {
      type: "area",
      height: height,
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      },
      sparkline: {
        enabled: true
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'smooth',
      width: 2,
      colors: [lineClr]
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.45,
        opacityTo: 0.05,
        stops: [50, 100]
      }
    },
    tooltip: {
      theme: 'light',
      fixed: {
        enabled: false
      },
      x: {
        show: false
      },
      y: {
        title: {
          formatter: function (seriesName) {
            return ''
          }
        }
      },
      marker: {
        show: false
      }
    },
    grid: {
      show: false
    },
    xaxis: {
      type: 'category',
      categories: chartData?.categories || [],
      labels: {
        show: false
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      }
    },
    yaxis: {
      show: false,
      min: 0,
      max: Math.max(...(chartData?.data || [])) * 1.2
    },
    markers: {
      size: 0,
      strokeWidth: 0
    },
    colors: [lineClr]
  };

  return (
    <div style={{ height: height, width: '100%' }}>
      <ReactApexChart
        options={options}
        series={series}
        type="area"
        height={height}
        width="100%"
      />
    </div>
  );
}